import * as React from 'react';
import clsx from 'clsx';
import { Message } from '../Private/Message/Message';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "Notification-root_rkmjn",
  "message": "Notification-message_4Q-RZ"
};
function getMessageContent(message) {
  if (typeof message === 'string') {
    return /*#__PURE__*/_jsx("p", {
      children: message
    });
  }
  if (typeof message === 'object' && '__html' in message) {
    return /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: message
    });
  }
  if (/*#__PURE__*/React.isValidElement(message)) {
    return message;
  }
  if (Array.isArray(message)) {
    return message.map((mess, idx) => {
      if (typeof mess === 'object' && '__html' in mess) {
        return /*#__PURE__*/_jsx("div", {
          dangerouslySetInnerHTML: mess
        }, `message-${idx}`);
      }
      return /*#__PURE__*/_jsx("div", {
        children: mess
      }, `message-${idx}`);
    });
  }
  return null;
}
function Notification({
  id,
  message,
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Message, {
    withIcon: true,
    withHighlight: true,
    dismissible: true,
    buttonsAlign: "end",
    className: clsx(styles.root, className),
    classes: {
      content: styles.message
    },
    ...extraProps,
    children: getMessageContent(message)
  });
}
export default Notification;